import IPlayer from '../Player/Interfaces/IPlayer';
import IModule from '../Shared/Interfaces/IModule';

import UiType         from './Shared/Constants/UiType';
import IUi            from './Shared/Interfaces/IUi';
import IUiConstructor from './Shared/Interfaces/IUiConstructor';

const fetchUiModule = async (type: UiType): Promise<IModule> => {
    switch (type) {
        case UiType.BROWSER:
            return await import(/* webpackChunkName: "ui.browser" */ './Browser/');
    }
};

/**
 * A factory for detecting the appropriate UI for the environment,
 * asyncronously loading its entry point (via a code split "chunk"), and returning an
 * instance of it.
 */

const uiFactory = async (player: IPlayer): Promise<IUi> => {
    const module = await fetchUiModule(UiType.BROWSER);
    const Ui: IUiConstructor = module.default;

    return new Ui(player);
};

export default uiFactory;